import React from "react";
import { CommunitiesLandingPage } from "@/components/communities";

export default function Communities() {
  return <CommunitiesLandingPage />;
}
